import { ActionButtons } from "./ActionButtons";
import { SelectInput } from "./SelectInput";
import styles from "../editable-select-cell.module.scss";

export function EditView({
	containerRef,
	expandOnEdit,
	isCreatable,
	selectRef,
	selectedValue,
	setSelectedValue,
	handleCreateOption,
	dynamicOptions,
	isMulti,
	isClearable,
	isSearchable,
	isSaving,
	disabled,
	placeholder,
	noOptionsMessage,
	loadingMessage,
	formatCreateLabel,
	getOptionValue,
	getOptionLabel,
	handleKeyDown,
	setMenuIsOpen,
	components,
	persistChange,
	cancelEdit,
	savingText,
	saveText,
	cancelText,
	errorText,
	className,
	filterOption,
}) {
	return (
		<div className={`${styles.wrapper} ${className}`} ref={containerRef} onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
			<div className={expandOnEdit ? styles.popover : styles.inlineEdit}>
				<div className={styles.selectWrapper}>
					<SelectInput
						isCreatable={isCreatable}
						selectRef={selectRef}
						selectedValue={selectedValue}
						onChange={setSelectedValue}
						onCreateOption={handleCreateOption}
						dynamicOptions={dynamicOptions}
						isMulti={isMulti}
						isClearable={isClearable}
						isSearchable={isSearchable}
						isSaving={isSaving}
						disabled={disabled}
						placeholder={placeholder}
						noOptionsMessage={noOptionsMessage}
						loadingMessage={loadingMessage}
						formatCreateLabel={formatCreateLabel}
						getOptionValue={getOptionValue}
						getOptionLabel={getOptionLabel}
						onKeyDown={handleKeyDown}
						onMenuOpen={() => setMenuIsOpen(true)}
						onMenuClose={() => setMenuIsOpen(false)}
						components={components}
						filterOption={filterOption}
						className={styles.selectInput}
					/>
				</div>

				<ActionButtons
					isSaving={isSaving}
					disabled={disabled}
					savingText={savingText}
					saveText={saveText}
					cancelText={cancelText}
					onSave={persistChange}
					onCancel={cancelEdit}
				/>

				{errorText ? <div className={styles.errorText}>{errorText}</div> : null}
			</div>
		</div>
	);
}
